/**
 * Returns a string in which only the first character
 * is capitalized and the remaining characters are
 * converted to lowercase if they are not already
 */

export const capitalizeFirstLetter = (stringValue: string) =>
  stringValue.charAt(0).toUpperCase() + stringValue.slice(1).toLowerCase();
